<script setup>
import { AccordionHeader, AccordionTrigger, useForwardProps } from "reka-ui";

import SvgIcon from "@/components-ng/SvgIcon.vue";

const props = defineProps({
  asChild: { type: Boolean, default: false },
  as: { type: [String, Object], default: "button" },
});

const forwarded = useForwardProps(props);
</script>

<template>
  <AccordionHeader class="accordion-header">
    <AccordionTrigger v-bind="forwarded" class="accordion-trigger">
      <slot />
      <SvgIcon class="accordion-chevron" name="system/chevron-down" width="20" height="20" />
    </AccordionTrigger>
  </AccordionHeader>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;

.accordion-header {
  display: flex;
  margin: 0;
}

.accordion-trigger {
  appearance: none;
  background: none;
  border: none;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 1.75rem;
  cursor: pointer;
  text-align: left;
  color: c.$text;

  &:hover {
    background-color: c.$background-grey-light;
  }
}

.accordion-chevron {
  flex-shrink: 0;
  margin-left: auto;
  color: c.$text-subtle;

  [data-state="open"] & {
    transform: rotate(180deg);
  }
}
</style>
